// import { LOGIN, LOGOUT, NOT_AUTHENTICATED } from '../actions.type'
import { loadLanguageAsync } from '@/i18n-setup'
import { UPDATE_LANGUAGE } from '../actions.type'
import { SET_LANGUAGE } from '../mutations.type'

const state = {
  activeLanguage: localStorage.getItem('language') || 'en',
  languages: [{
    code: 'en',
    name: 'languages.english'
  },
  {
    code: 'fr',
    name: 'languages.french'
  }]
}

const getters = {
  language: state => state.languages.find(l => l.code === state.activeLanguage),
}

const actions = {
  [UPDATE_LANGUAGE]: ({ commit }, lang) => {
    loadLanguageAsync(lang)
      .then(() => {
        commit(SET_LANGUAGE, lang)
      })
  }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
  [SET_LANGUAGE]: (state, lang) => {
    state.activeLanguage = lang
    localStorage.setItem('language', lang)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
